import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import './App.css';

import withAuthentication from './Session/withAuthentication';
import withTheme from './withTheme';
import { withStyles } from '@material-ui/core/styles';

import util from 'lodash/util';
import * as routes from './Constants/routes';

import AppHeader from './CaazamApp/AppHeader';
import Home from  './CaazamApp/Home';
import Landing from  './CaazamApp/Landing';
import Profile from  './CaazamApp/Profile';
import SignIn from  './CaazamApp/SignIn';

import GoogleAnalytics from './Components/GoogleAnalytics';

const styles = (theme) => ({
  toolbar: theme.mixins.toolbar,

  version : {
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '50px',
    border: '1px solid',
  },
});

GoogleAnalytics.init();

class App extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Router>
          <div>
            <AppHeader />
            <div className={classes.toolbar} />
            <Route exact path={routes.LANDING} component={Landing} />
            <Route exact path={routes.HOME} component={Home} />
            <Route exact path={routes.SIGN_IN} component={SignIn} />
            <Route exact path={routes.PROFILE} component={Profile} />
            <GoogleAnalytics.RouteTracker />
          </div>
        </Router>
        {false && <div className={classes.version}>{require('../package.json').version}</div>}
      </div>
    );
  }
}


var enhance = util.flowRight(
  withAuthentication,
  withStyles(styles),
  withTheme);

export default enhance(App);



// WEBPACK FOOTER //
// ./src/App.js